module.exports = __webpack_public_path__ + "static/media/ayudante.9bcf37d6.svg";